import script from "./KpiChart.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiChart.vue?vue&type=script&setup=true&lang=js"

import "./KpiChart.vue?vue&type=style&index=0&id=18ce1649&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18ce1649"]])

export default __exports__